// @flow
import { RELATED_PRODUCTS } from 'Client/cms/toolkit/constants';
import { addTranslationKeys } from 'Src/i18n';
import * as configQueries from 'Views/configQueries';
import resortThumbnailQuery from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_RELATED_PRODUCTS } from 'Utils/request/requestDictionary';
import {
  type RelatedProductsCMSProps,
  type RelatedProductsGQLProps,
} from 'Components/lines/product-related-products-line/ProductRelatedProductsLine';

export const productRelatedProductsResolver = {
  name: RELATED_PRODUCTS,
  resolve(
    appContext: AppContext,
    props: RelatedProductsCMSProps,
  ): Promise<RelatedProductsGQLProps> {
    const { cmsContent = '', cmsRelease = '' } = appContext;
    const {
      resortId = '',
      tourDurationPlaceholder,
      cruiseTimingPlaceholder,
      cruiseDurationPlaceholder,
      dateFormat,
    } = props;
    const cmsArgs = `content: "${cmsContent}", release: "${cmsRelease}"`;
    const query = `query {
      product: resort(productId: "${resortId}") {
        relatedProducts {
          id
          ${resortThumbnailQuery({
            content: cmsContent,
            release: cmsRelease,
            tourDurationPlaceholder,
            cruiseTimingPlaceholder,
            cruiseDurationPlaceholder,
            dateFormat,
          })}
        }
      }
      config(${cmsArgs}) {
        ${configQueries.resort(appContext)}
        ${configQueries.price()}
        common {
          next
          previous
          close
          thumbnailCTA
        }
      }
    }`;
    return graphQLClient
      .runQuery(query, appContext, {
        requestName: LINE_PRODUCT_RELATED_PRODUCTS,
        strictErrors: false,
      })
      .then(data => {
        addTranslationKeys(data.config);
        return data;
      });
  },
};
